module.exports = __webpack_public_path__ + "static/IoTHeaderIcon-c17585c3d4de7c6c8ef617a8d1bc1c9d.svg";